import LandingEventsChart from '@/components/stats/landing-events-chart';
import LandingTelegramAuthFunnelChart from '@/components/stats/landing-telegram-auth-funnel-chart';
import LandingTelegramAuthTimeseriesChart from '@/components/stats/landing-telegram-auth-timeseries-chart';
import SummaryCards from '@/components/stats/summary-cards';
import type { ILandingEventStats } from '@/entities/landing.entity';
import { LANDING_EVENT_TYPE_LABELS } from '@/entities/landing.entity';
import { formatRateFraction, formatTwoFaShare } from '@/entities/landing-telegram-auth-funnel';
import LandingEventsHeroCard from './landing-events-hero-card';
import {
	DownloadIcon,
	FileTextIcon,
	MousePointerClickIcon,
	PercentIcon,
	ShieldCheckIcon,
	SmartphoneIcon,
} from 'lucide-react';

interface LandingEventsStatsViewProps {
	stats: ILandingEventStats;
}

export default function LandingEventsStatsView({ stats }: LandingEventsStatsViewProps) {
	const tg = stats.telegramAuth.totals;

	return (
		<div className='flex flex-col gap-4'>
			<LandingEventsHeroCard
				classicAllTime={stats.allTime}
				telegramAuth={stats.telegramAuth.allTime.totals}
			/>

			<div className='flex flex-col gap-2'>
				<h3 className='text-sm font-semibold text-muted-foreground px-0.5'>Трафик</h3>
				<SummaryCards
					className='sm:grid-cols-3'
					cards={[
						{
							icon: MousePointerClickIcon,
							label: LANDING_EVENT_TYPE_LABELS.connect,
							value: stats.totals.connect.toLocaleString('ru-RU'),
							color: 'text-chart-1',
						},
						{
							icon: DownloadIcon,
							label: LANDING_EVENT_TYPE_LABELS.download,
							value: stats.totals.download.toLocaleString('ru-RU'),
							color: 'text-chart-2',
						},
						{
							icon: FileTextIcon,
							label: LANDING_EVENT_TYPE_LABELS.form_submit,
							value: stats.totals.form_submit.toLocaleString('ru-RU'),
							color: 'text-chart-3',
						},
					]}
				/>
				<LandingEventsChart
					data={stats.eventsOverTime}
					series={['connect', 'download', 'form_submit']}
					title='Трафик по времени'
				/>
			</div>

			<div className='flex flex-col gap-2'>
				<h3 className='text-sm font-semibold text-muted-foreground px-0.5'>TG авторизация</h3>
				<SummaryCards
					className='sm:grid-cols-2 lg:grid-cols-4'
					cards={[
						{
							icon: SmartphoneIcon,
							label: 'Старты',
							value: tg.starts.toLocaleString('ru-RU'),
							color: 'text-chart-4',
						},
						{
							icon: ShieldCheckIcon,
							label: 'Сессии',
							value: tg.sessions.toLocaleString('ru-RU'),
							color: 'text-chart-2',
						},
						{
							icon: PercentIcon,
							label: 'Старт → сессия',
							value: formatRateFraction(tg.sessionFromStart),
							color: 'text-chart-5',
						},
						{
							icon: PercentIcon,
							label: 'Успех кода',
							value: formatRateFraction(tg.codeSuccessRate),
							color: 'text-chart-1',
						},
					]}
				/>
				<p className='text-xs text-muted-foreground px-0.5'>
					Доля визитов с 2FA (awaitingPassword): {formatTwoFaShare(tg)}
				</p>
				<LandingTelegramAuthFunnelChart funnel={stats.telegramAuth.funnel} />
				<LandingTelegramAuthTimeseriesChart data={stats.telegramAuth.overTime} />
			</div>
		</div>
	);
}
